import { useEffect, useMemo } from 'react';
import type { UseFormSetValue } from 'react-hook-form';
import { computeCampWeekSessionDates, type LessonFormData } from '@court-sync/shared';

export const CAMP_DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

export function sortCampSessionDates(dates: string[] | undefined): string[] {
  return [...(dates ?? [])].filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)).sort();
}

export function campSessionDatesToExplicitSlots(
  dates: string[],
  startTime: string,
  endTime: string
): Array<{ sessionDate: string; startTime: string; endTime: string }> {
  return sortCampSessionDates(dates).map((sessionDate) => ({
    sessionDate,
    startTime,
    endTime,
  }));
}

export function useCampWeekSchedule(
  enabled: boolean,
  startDate: string,
  selectedDaysOfWeek: number[],
  setValue: UseFormSetValue<LessonFormData>
): string[] {
  const computedWeekDates = useMemo(
    () => (enabled ? computeCampWeekSessionDates(startDate, selectedDaysOfWeek) : []),
    [enabled, startDate, selectedDaysOfWeek]
  );

  useEffect(() => {
    if (!enabled) return;
    setValue('campSessionDates', computedWeekDates, { shouldValidate: true });
    setValue(
      'endDate',
      computedWeekDates.length > 0 ? computedWeekDates[computedWeekDates.length - 1]! : '',
      { shouldValidate: true }
    );
  }, [computedWeekDates, enabled, setValue]);

  return computedWeekDates;
}
